import * as React from "react"
import { LogoSkeleton, LogoProps } from "./skeleton"

export function StrapiLogo(props: LogoProps) {
  return (
    <LogoSkeleton {...props} logoName="StrapiLogo">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.2705 13.593V7.13984C13.2705 6.91 13.0842 6.72368 12.8544 6.72368H6.40845V0.0625H19.5085C19.7384 0.0625 19.9247 0.24882 19.9247 0.478657V13.593H13.2705Z"
        fill="#8E75FF"
      />
      <path
        opacity="0.404989"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.40835 0.0625V6.72368H0.256181C0.141259 6.72368 0.0480957 6.63053 0.0480957 6.51561C0.0480957 6.46046 0.0699878 6.40757 0.108962 6.36855L6.40835 0.0625Z"
        fill="#8E75FF"
      />
      <path
        opacity="0.404989"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.2704 19.7519V13.5934H19.9246L13.6257 19.8989C13.5445 19.9802 13.4127 19.9803 13.3314 19.8991C13.2924 19.8601 13.2704 19.8071 13.2704 19.7519Z"
        fill="#8E75FF"
      />
      <path
        opacity="0.404989"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.40845 6.72363H13.0625C13.1774 6.72363 13.2705 6.81679 13.2705 6.93171V13.593H6.82462C6.59477 13.593 6.40845 13.4067 6.40845 13.1768V6.72363Z"
        fill="#8E75FF"
      />
    </LogoSkeleton>
  )
}
